export default {
  // 侧边栏默认折叠状态
  menu: {
    asideCollapse: false,
  },
  // 在读取持久化数据失败时默认页面
  page: {
    opened: [
      {
        name: 'home',
        fullPath: '/home',
        path: '/home',
        meta: {
          title: '主页',
          tabId: 'home',
          icon: 'home',
          aliveName: 'home',
          closable: false,
        },
      },
    ],
  },
  // 默认navId，用于顾虑第一层菜单树，注意严格匹配树类型，1001与 '1001'是不相等
  navId: 1001,
  // 注册的主题
  theme: {
    list: [
      // {
      //   title: 'd2admin 经典',
      //   name: 'd2',
      //   preview: 'image/theme/d2/preview@2x.png',
      // },
    ],
  },
  // 是否默认开启页面切换动画
  transition: {
    active: true,
  },
};
